import qs from 'qs'
import { toast } from 'react-toastify'
import HttpHandler from 'app/reusable/HttpHandler'

// Downloads the attendance lists PDF for `params.cycle` and the classes in
// `params.selected` (ids, or 'all').
export const printAttendanceList = (params) =>
  toast.promise(
    HttpHandler._fileDownload(
      `${HttpHandler.getPrintPath(
        'activities',
        'activity-class-print-attendance-list',
        ''
      )}?${qs.stringify(params, {
        arrayFormat: 'repeat',
      })}`,
      `Chamada.pdf`,
      'GET',
      {},
      true
    ),
    {
      pending: 'Gerando o arquivo...',
      success: 'Arquivo gerado!',
      error: 'Erro ao gerar o arquivo.',
    }
  )
